import * as React from "react";
import {option, Option} from "ts-option";
import AssetSpecification from "../../../../model/asset/AssetSpecification";
import DropDown from "../../../../hiberUiKit/src/molecules/DropDown/DropDown";

interface IProps {
	/**
	 * Item asset to edit
	 */
	item: AssetSpecification;
	/**
	 * On asset value change callback.
	 * @param value
	 */
	onChange: (value: Option<string>) => void;
}

export default class AssetSpecificationEfficiencySelector extends React.Component<IProps, {}> {

	constructor(props: IProps) {
		super(props);
		this.hotWaterEfficiencyChange = this.hotWaterEfficiencyChange.bind(this);
		this.heatingEfficiencyChange = this.heatingEfficiencyChange.bind(this);
	}

	heatingEfficiency = ["A++", "A+", "A", "B", "C", "D", "E", "F", "G"];
	hotWaterEfficiency = ["A", "B", "C", "D", "E", "F", "G"];

	render() {

		const heatingEfficiency = this.props.item.value.split(",")[0];
		const hotWaterEfficiency = this.props.item.value.split(",")[1];

		return (
			<div className={"c-assets-efficiency"}>
				<div className={"c-assets-efficiency_title"}>{this.props.item.label}</div>
				<div className={"c-assets-efficiency_item"}>
					<label>Heating: </label>
					<DropDown items={this.heatingEfficiency}
							  itemToId={(item) => item.toString()}
							  itemToLabel={(item) => item.toString()}
							  selectedItemId={heatingEfficiency}
							  onSelect={this.heatingEfficiencyChange}/>
				</div>
				<div className={"c-assets-efficiency_item"}>
					<label>Hot water: </label>
					<DropDown items={this.hotWaterEfficiency}
							  itemToId={(item) => item.toString()}
							  itemToLabel={(item) => item.toString()}
							  selectedItemId={hotWaterEfficiency}
							  onSelect={this.hotWaterEfficiencyChange}/>
				</div>
			</div>
		);
	}

	heatingEfficiencyChange(value: string) {
		this.props.onChange(option([value, this.props.item.value.split(",")[1]].join(",")))
	}

	hotWaterEfficiencyChange(value: string) {
		this.props.onChange(option([this.props.item.value.split(",")[0], value].join(",")));
	}
}